import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';

export type SystemTemplateProps = {
  /** An EmptyState with the matching illustration and one next step (404, 500, expired job, alert confirm, unsubscribe, access denied). */
  children: ReactNode;
  className?: string;
};

/** System pages: one centred EmptyState. The sign-in prompt is a Dialog and the CookieBanner is global; neither needs a page. */
export function SystemTemplate({ children, className }: SystemTemplateProps) {
  return (
    <PageContainer width="prose" className={className}>
      <div className="flex min-h-120 items-center justify-center py-jc-section">{children}</div>
    </PageContainer>
  );
}
